window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  function formatPrice(price, decimals) {
    if (typeof decimals === "undefined") {
      decimals = 2;
    }
    var negative = price < 0 ? "-" : "";
    return (
      negative +
      "$" +
      Math.abs(price)
        .toFixed(decimals)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    );
  }

  function formatDateAsLong(date) {
    var cfg = ns.config;
    var d = moment(date, "YYYYMMDD");
    var mask = cfg.site === "brisbane" ? "dddd, Do MMMM" : "dddd MMMM Do";
    if (d.year() !== cfg.today.year()) {
      mask += cfg.site === "brisbane" ? " YYYY" : ", YYYY";
    }
    return d.format(mask);
  }

  function formatDate(date) {
    var cfg = ns.config;
    var d = moment(date, "YYYYMMDD");
    var mask = cfg.site === "brisbane" ? "Do MMMM" : "MMMM Do";
    if (d.year() !== cfg.today.year()) {
      mask += cfg.site === "brisbane" ? " YYYY" : ", YYYY";
    }
    return d.format(mask);
  }

  function formatTime(time) {
    return moment(time, "HH:mm").format("h:mm A");
  }

  function round10(num) {
    return +(Math.round(num + "e+" + 2) + "e-" + 2);
  }

  function showAlert(message) {
    $(".alert-row").show().find(".alert-message").text(message);
  }

  function hideAlert() {
    $(".alert-row").attr({ style: "display: none!important" });
  }

  ns.utils = {
    formatPrice: formatPrice,
    formatDate: formatDate,
    formatDateAsLong: formatDateAsLong,
    formatTime: formatTime,
    round10: round10,
    showAlert: showAlert,
    hideAlert: hideAlert,
  };
})(window.EM.booking);
